import React from "react";
import styled from "styled-components";
import { SearchBar } from "../components/search/SearchBar";
import { useSearch } from "../hooks/useSearch";
import { SearchResults } from "../components/search/SearchResults";
import { SearchSuggestions } from "../components/search/SearchSuggestions";
import { DeviceDetails } from "../components/search/DeviceDetails";
import { SearchLoading } from "../components/search/SearchLoading";
import { RecentRecords } from "../components/records/RecentRecords";
import {
  getUniqueDeviceTypes,
  getUniqueSerialNumbers,
  convertToRecords,
} from "../utils/searchUtils";

// Main container with a clean background
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  min-height: 100vh;
  /* background-color: ${({ theme }) => theme.colors.background}; */
`;

// Hero section for the search bar
const SearchHero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0 0 0;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    padding: 40px 0 20px 0;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;

  img {
    height: 50px;
    width: auto;
  }
`;

const SearchBarWrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  transition: all 0.3s ease;
`;

const RecentRecordsContainer = styled.div`
  margin-top: 80px;
  position: relative;
`;

const SearchResultsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const SearchResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 820px;
  width: 100%;
`;

export const SearchView: React.FC = () => {
  const {
    searchQuery,
    results,
    loading,
    hasSearched,
    selectedDevice,
    parseMetadata,
    handleSearch,
    handleItemClick,
  } = useSearch();

  const handleSuggestionClick = (suggestion: string) => {
    handleSearch(suggestion);
  };

  return (
    <Container>
      <SearchHero>
        <LogoContainer>
          <img src="/verae-logo-black.svg" alt="Verae Logo" />
        </LogoContainer>

        <SearchBarWrapper>
          <SearchBar
            onSearch={handleSearch}
            placeholder="Search by serial number, model, etc..."
            initialValue={searchQuery}
          />
        </SearchBarWrapper>

        {hasSearched && (
          <SearchSuggestions
            deviceTypes={getUniqueDeviceTypes(results, parseMetadata)}
            serialNumbers={getUniqueSerialNumbers(results, parseMetadata)}
            onSuggestionClick={handleSuggestionClick}
          />
        )}
      </SearchHero>

      {loading ? (
        <SearchLoading />
      ) : hasSearched && searchQuery.trim().length > 0 ? (
        <SearchResultsContainer>
          <SearchResultsWrapper>
            {selectedDevice && (
              <DeviceDetails
                selectedDevice={selectedDevice}
                records={convertToRecords(results, parseMetadata)}
              />
            )}

            <SearchResults
              results={results}
              selectedDevice={selectedDevice}
              parseMetadata={parseMetadata}
              onItemClick={handleItemClick}
              searchQuery={searchQuery}
            />
          </SearchResultsWrapper>
        </SearchResultsContainer>
      ) : (
        <RecentRecordsContainer>
          <RecentRecords format="grid" />
        </RecentRecordsContainer>
      )}
    </Container>
  );
};
